import { gql } from '@grandvisionhq/graphql';
import { baseProductFragment } from './fragments/base-product.js';
import { baseVariantFragment } from './fragments/base-variant.js';

const GET_PRODUCTS_BY_SKUS_EXTENDED = gql`
  query GetProductsBySKUs($skus: [String!]!) {
    getProductsBySKUs(skus: $skus) {
      ...BaseProductFragment
      taxCategory {
        rate {
          amount
        }
      }
      ratingsSummary {
        average
        reviewCount
      }
      ... on FrameProduct {
        productTypeDetails {
          isExclusiveBrand
          isOfferedWithPrescriptions
          offerings {
            includesLenses
          }
        }
      }
      ... on SunglassesProduct {
        productTypeDetails {
          isExclusiveBrand
          isOfferedWithPrescriptions
        }
      }
      variants {
        ...BaseVariantFragment
        ... on FrameVariant {
          inventory {
            totalQuantity
          }
          variantTypeDetails {
            isInsuranceReimbursable
            frameFeatures {
              material
              shape {
                displayName
              }
              type
            }
            faceShape {
              shape
            }
            targetGender
            maybeBrandModel: brandModel
            maybeBrandModelCode: brandModelCode
          }
        }
        ... on ContactLensVariant {
          inventory {
            totalQuantity
          }
          variantTypeDetails {
            lensType
            material
            lensColor
            packageQuantity
          }
        }
        ... on SolutionVariant {
          inventory {
            totalQuantity
          }
          variantTypeDetails {
            contactLensCareType
            volume
            volumeUnit
            packageOption
            solutionType
          }
        }
        ... on AccessoriesVariant {
          inventory {
            totalQuantity
          }
          variantTypeDetails {
            accessoryType {
              displayName
            }
            color
            material
            targetGender
            brandModel
            brandModelCode
          }
        }
        ... on SunglassesVariant {
          inventory {
            totalQuantity
          }
          variantTypeDetails {
            maybeFrameFeatures: frameFeatures {
              material
              shape {
                displayName
              }
              type
            }
            faceShape {
              shape
            }
            targetGender
            maybeBrandModel: brandModel
            maybeBrandModelCode: brandModelCode
          }
        }
        ... on ReadyReaderVariant {
          inventory {
            totalQuantity
          }
          variantTypeDetails {
            maybeFrameFeatures: frameFeatures {
              material
              shape {
                displayName
              }
              type
            }
            power
            targetGender
            maybeBrandModel: brandModel
            maybeBrandModelCode: brandModelCode
          }
        }
      }
    }
  }
  ${baseProductFragment}
  ${baseVariantFragment}
`;

export { GET_PRODUCTS_BY_SKUS_EXTENDED };
//# sourceMappingURL=get-products-by-skus-extended.js.map
